// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,ScoreCard,StatsGraph
}                         from '../../components';
import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../components';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';

class Collection extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Collection');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    console.log('Enabling collection graph - Workaround');
    $('.collection-trend').find("a").trigger("click");
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Collection');
  }

  state = {
    headers: [
      {name: 'Data', tablink: 'about', isActive: true},
      {name: 'Collections Trend', tablink: 'home', isActive: false},
    ]
  };

  render() {
    const {
      statsTable,scoreCard,statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(
      <div>
        <div className="row" style={{padding: '1%'}}>
          <Link to="./crud/addSubscription">
            <RaisedButton
              label="Add Subscription"
              style={{float:'right'}}
              secondary={true}
            />

          <Link to="./crud/editTarget">
            <RaisedButton
              label="Edit Target"
              style={{float:'right',display:'none'}}
              secondary={false}
            />
          </Link>
          </Link>
        </div>
       
        <div className="row collection-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.headers}/>
            <TabPanelBody>
              <TabPanelBodyContent id="home">
                <StatsGraph type="bar" name="collection_trends" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="about">
                <StatsTable name="collection_trends" data={statsTable} displayName="Collection Trends" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>

        <div className="row">
          <StatsTable name="cash_collection_per_day" displayName="Collection Per Day" bigTable={true} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row">
          <StatsTable name="cash_collection_report" datefilter={true} displayName="Collection Report" bigTable={true} data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
      </div>
    );
  }
}

export default Collection;



// WEBPACK FOOTER //
// ./src/app/views/collection/Collection.js